import { useQuery } from '@tanstack/react-query';
import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';
import {
  getCandidateById,
  getCandidates,
} from '../services/candidatesServices';

export const useGetCandidates = (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['candidates', paginatedParams, searchCriteria],
    queryFn: () => getCandidates(paginatedParams, searchCriteria),
    enabled,
  });
};

export const useGetCandidateById = (id: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['candidate', id],
    queryFn: () => getCandidateById(id),
    enabled,
  });
};
